import { DetailPage } from "@/pages/DetailPage";
import { DetailPageErrorComponent } from "@/pages/details/DetailPageErrorComponent";
import { DetailPageParams } from "@/pages/details/schemata";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/apps/$appId",
)({
  params: {
    parse: (params) => DetailPageParams.parse(params),
  },
  validateSearch: (search) => search,
  component: DetailPage,
  errorComponent: DetailPageErrorComponent,
});
